import React from 'react';
import translations from '../utils/translations';

const Sidebar = ({ 
  savedICs, 
  currentIC, 
  isLoading, 
  isSaving, 
  onCreateNewIC, 
  onLoadIC, 
  onDeleteIC, 
  onSaveIC,
  current_locale = 'en',
  isRTL = false
}) => {
  // Get translations based on locale
  const t = translations[current_locale] || translations['en'];
  return (
    <div style={{ 
      height: '100%', 
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '15px',
        direction: isRTL ? 'rtl' : 'ltr'
      }}>
        <h3 style={{ 
          margin: 0, 
          color: '#2c3e50',
          fontSize: '16px',
          fontWeight: '600',
        }}>{t.savedICs}</h3>
        <button 
          onClick={onCreateNewIC}
          style={{
            backgroundColor: '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}
        >
          <span style={{ fontSize: '14px' }}>+</span> {t.newIC}
        </button>
      </div>
      
      <div style={{ 
        borderBottom: '2px solid #3498db',
        marginBottom: '15px',
        paddingBottom: '5px'
      }}></div>
      
      {!Array.isArray(savedICs) || savedICs.length === 0 ? (
        <div style={{ 
          padding: '15px', 
          textAlign: 'center', 
          color: '#7f8c8d',
          backgroundColor: '#f8f9fa',
          borderRadius: '6px',
          border: '1px dashed #bdc3c7',
          fontSize: '14px'
        }}>
          {t.noSavedICs}
        </div>
      ) : (
        (Array.isArray(savedICs) ? savedICs : []).map((ic) => (
          <div 
            key={ic.id}
            style={{ 
              marginBottom: '12px', 
              padding: '10px', 
              backgroundColor: currentIC && (currentIC.id === ic.id || currentIC.id === parseInt(ic.id)) ? '#ebf7ff' : '#fff', 
              borderRadius: '6px', 
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              border: currentIC && (currentIC.id === ic.id || currentIC.id === parseInt(ic.id)) ? '1px solid #3498db' : '1px solid #e6e6e6',
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out'
            }}
            onClick={() => onLoadIC(ic)}
            onMouseOver={(e) => {
              if (!currentIC || (currentIC.id !== ic.id && currentIC.id !== parseInt(ic.id))) {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
              }
            }}
            onMouseOut={(e) => {
              if (!currentIC || (currentIC.id !== ic.id && currentIC.id !== parseInt(ic.id))) {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
              }
            }}
          >
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '5px',
              direction: isRTL ? 'rtl' : 'ltr'
            }}>
              <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{ic.name}</div>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteIC(ic.id);
                }}
                style={{
                  backgroundColor: 'transparent',
                  color: '#e74c3c',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  padding: '0',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  opacity: '0.7'
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = '1'}
                onMouseOut={(e) => e.currentTarget.style.opacity = '0.7'}
              >
                ×
              </button>
            </div>
            <div style={{ fontSize: '12px', color: '#7f8c8d' }}>
              {t.pins} {ic.vertical_pins || ic.verticalPins}×{ic.horizontal_pins || ic.horizontalPins}
            </div>
            {ic.description && (
              <div style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '5px', fontStyle: 'italic' }}>
                {ic.description}
              </div>
            )}
          </div>
        ))
      )}
      
      <div style={{ marginTop: 'auto', paddingTop: '10px', paddingBottom: '0' }}>
        <button 
          onClick={onSaveIC}
          disabled={isLoading || isSaving}
          style={{
            backgroundColor: isSaving ? '#a9dfbf' : '#2ecc71',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 12px',
            width: '100%',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: (isLoading || isSaving) ? 'not-allowed' : 'pointer',
            marginBottom: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            transition: 'background-color 0.3s'
          }}
        >
          {isSaving ? (
            <>
              <span style={{ 
                display: 'inline-block',
                width: '16px',
                height: '16px',
                border: '2px solid rgba(255,255,255,0.3)',
                borderRadius: '50%',
                borderTopColor: 'white',
                animation: 'spin 1s linear infinite',
                marginRight: '8px'
              }}></span>
              {t.saving}
            </>
          ) : (
            <>
              <span style={{ fontSize: '16px' }}>💾</span> {t.saveCurrentIC}
            </>
          )}
        </button>
        
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Sidebar;
